var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.product.catalog === _vm.config.rootcategories.drukowanie
      ? _c("div", { staticClass: "price sans-serif" }, [
          (_vm.product.special_price_incl_tax > 0 &&
            _vm.product.is_promotion === true) ||
          (_vm.product.is_suggested === true &&
            _vm.product.special_price_incl_tax > _vm.product.price_incl_tax)
            ? _c("div", { staticClass: "h3 cl-secondary" }, [
                _c("span", { staticClass: "h2 weight-700 cl-indigo" }, [
                  _vm._v(
                    "\n\n        " +
                      _vm._s(
                        _vm._f("price")(
                          _vm.product.price_incl_tax,
                          _vm.storeView
                        )
                      ) +
                      "\n\n        "
                  )
                ]),
                _vm._v(" \n      "),
                _c("span", { staticClass: "price-original h3" }, [
                  _vm._v(
                    "\n\n      " +
                      _vm._s(
                        _vm._f("price")(
                          _vm.product.special_price_incl_tax || 0,
                          _vm.storeView
                        )
                      ) +
                      "\n\n      "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.product.special_price_incl_tax && _vm.product.price_incl_tax
            ? _c("div", { staticClass: "h2 weight-700 cl-indigo" }, [
                _vm._v(
                  "\n\n      " +
                    _vm._s(
                      _vm._f("price")(_vm.product.price_incl_tax, _vm.storeView)
                    ) +
                    "\n\n    "
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.product.catalog === _vm.config.rootcategories.biuro
      ? _c("div", { staticClass: "price sans-serif" }, [
          (_vm.product.special_price_incl_tax > 0 &&
            _vm.product.is_promotion === true) ||
          (_vm.product.is_suggested === true &&
            _vm.product.special_price_incl_tax > _vm.product.price_incl_tax)
            ? _c("div", { staticClass: "h3 cl-secondary" }, [
                _c(
                  "span",
                  { staticClass: "h2 weight-700 office-price-color" },
                  [
                    _vm._v(
                      "\n\n        " +
                        _vm._s(
                          _vm._f("price")(
                            _vm.product.price_incl_tax,
                            _vm.storeView
                          )
                        ) +
                        "\n\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "price-original" }, [
                  _vm._v(
                    "\n\n        " +
                      _vm._s(
                        _vm._f("price")(
                          _vm.product.special_price_incl_tax || 0,
                          _vm.storeView
                        )
                      ) +
                      "\n\n        "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.product.special_price_incl_tax && _vm.product.price_incl_tax
            ? _c("div", { staticClass: "h2 weight-700 office-price-color" }, [
                _vm._v(
                  "\n    \n      " +
                    _vm._s(
                      _vm._f("price")(_vm.product.price_incl_tax, _vm.storeView)
                    ) +
                    "\n\n    "
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }